import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const label = (theme: Theme) => css`
  label {
    color: ${theme.text.emphasis};
  }
`;
